// React.
import { useContext } from 'react';

// Third-parties.
import { useToasts } from 'react-toast-notifications';

// Helper.
import Helper from '../../helpers/Helper';

// Types.
import FilterOption from '../../types/instance/FilterOption';
import { FilterType } from '../../typescript/Enums';
import { getStatisticsParameters } from "../../helpers/utils";
import {STATISTICS_FILTERS} from "../../container/statistics/constants";
import { TimeRangeContext } from "../../context/TimeRangeContext";
import { FilterContext } from "../../context/FilterContext";

function CopyUrl(props: { useUrl: boolean }) {
    const { addToast } = useToasts();
    const timeRangeContext = useContext(TimeRangeContext);
    const { currentFilterOptions } = useContext(FilterContext);

    function copyLinkToClipboard() {

        let target = document.createElement('textarea');

        target.style.position = 'absolute';
        target.style.left = '-9999px';
        target.style.top = '0';
        target.id = '_hiddenUrlCopyText_';

        let filters: string = '';
        let statisticFilters: string = '';

        // Use current filter options from context
        currentFilterOptions.forEach((filterOption: FilterOption) => {
            if (filterOption.filters.length > 0) {
                filters += `&${FilterType[filterOption.filterType].toLowerCase()}=${filterOption.filters.join()}`
            }
        });
        // let tabToHide = ''
        // const hideTab = getParameterValues(window.location.search, 'hide')
        // if (hideTab.length) {
        //     tabToHide = `&hide=${hideTab}`
        // }

        statisticFilters = getStatisticsParameters(STATISTICS_FILTERS);
        let instanceTagsParams = '';
        const savedInstanceTags = window.localStorage.getItem('instance-tags-filters');
        if (savedInstanceTags) {
            const filters = JSON.parse(savedInstanceTags);
            // Convert the new filter format to URL parameters
            const tagParams = Object.entries(filters)
                .map(([tagName, tagValues]) => `${tagName}:${(tagValues as string[]).join(',')}`)
                .join(';');
            if (tagParams) {
                instanceTagsParams = `&tags=${tagParams}`;
            }
        }

        if (props.useUrl === false) {

            // Build the URL address.
            target.textContent = `${window.location.href.split(/[?#]/)[0]}${Helper.getQueryStringWithInterval(timeRangeContext)}${filters}${statisticFilters}${instanceTagsParams}`;
        } else {

            // Use the existing URL address.
            target.textContent = window.location.href;
        }
        document.body.appendChild(target);

        // Select the text within the hidden input.
        target.select();
        target.setSelectionRange(0, 99999);

        document.execCommand("copy");

        // Add a toast notification.
        addToast('Web address copied to your clipboard', { appearance: 'info', autoDismiss: true });
    }
        

    return (
        <button type="button" className="btn btn-heading" data-tooltip-id="global-tooltip" data-tooltip-content="Copy this view's URL and period to your clipboard" onClick={copyLinkToClipboard}><i className="fal fa-copy fa-fw"></i></button>
    );
}

CopyUrl.defaultProps = {
    useUrl: false
};

export default CopyUrl;
